"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AppointmentCreateRequestSchema () {
        return AppointmentCreateRequestSchema;
    },
    get AppointmentCreateResponseSchema () {
        return AppointmentCreateResponseSchema;
    }
});
const _zod = require("zod");
const _optionaltrimmedtext = require("./optional-trimmed-text");
const _visittype = require("./visit-type");
const AppointmentCreateRequestSchema = _zod.z.object({
    patientId: _zod.z.string().uuid(),
    providerId: _zod.z.string().uuid(),
    scheduledAt: _zod.z.string().datetime({
        offset: true
    }),
    durationMinutes: _zod.z.number().int().min(5).max(240).default(30),
    visitType: _visittype.VisitTypeSchema,
    reason: (0, _optionaltrimmedtext.optionalTrimmedText)(120),
    room: (0, _optionaltrimmedtext.optionalTrimmedText)(40)
}).strict();
const AppointmentCreateResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid()
});
